module.exports = __webpack_public_path__ + "static/img/02-01.036f650d.png";